/*
 * Filename: rule-elements.model.ts
 * Error store: This file represents the model for templates that will be displayed on homepage.
 */

import { types, ModelInstanceTypeProps, ModelProperties, getSnapshot } from 'mobx-state-tree';
import { CQMasterDataStore } from '../cq-master-data.store';

let initialState:any = {};
export const RulesElementsObject = types.model({
    FieldRuleElement: types.optional(types.frozen(), {}),
}).actions((self: any) => ({
    afterCreate: () => {
        initialState = getSnapshot(self);
    },
    reset() {
        Object.keys(self).forEach((itemKey: string) => {
            self[itemKey] = initialState[itemKey];
        });
    },
    setRuleElementObject(ObjectName:string , ruleType:string , ruleObject : {}){
        let ruleElements = {...self.FieldRuleElement};
        if(ruleElements.hasOwnProperty(ObjectName)){
            let ruleTypeObjectName = {...ruleElements[ObjectName]};
            ruleTypeObjectName[ruleType] = ruleObject;
            ruleElements[ObjectName] = ruleTypeObjectName;
        } else {
            ruleElements[ObjectName] = {[ruleType] : ruleObject};
        }
        self.FieldRuleElement = ruleElements;
    },
    setRuleElements(deployedRuleElements:any){
        self.FieldRuleElement = deployedRuleElements;
    },
    deleteAppliedRule(selectedTemplateName:string , objectName: string, deleteRuleObject: any) {
        const existingFieldObject = { ...self.FieldRuleElement };
        const existingRuleObject = { ...existingFieldObject[objectName] };
        const existingRuleKeys = Object.keys(existingRuleObject);
        if (existingRuleKeys.length > 1) {
            delete existingRuleObject[deleteRuleObject];
            existingFieldObject[objectName] = existingRuleObject;
        } else {
            delete existingFieldObject[objectName];
        }
        self.FieldRuleElement = existingFieldObject;
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(selectedTemplateName , 'ruleElements' , self.FieldRuleElement);
    },
    addGridObject(ruleElementsObject: any) {
        self.FieldRuleElement = ruleElementsObject;
    }
}));
